var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserRestrictedContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 62,
    fill: "#F9F9F9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5331_1400",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 124,
    height: 124
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 62,
    fill: "#F9F9F9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5331_1400)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5331_1400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.7144 73.04C74.1741 73.04 84.2747 62.9681 84.2747 50.5438C84.2747 38.1195 74.1741 28.0476 61.7144 28.0476C49.2547 28.0476 39.1542 38.1195 39.1542 50.5438C39.1542 62.9681 49.2547 73.04 61.7144 73.04Z",
    fill: "url(#paint0_linear_5331_1400)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.976 124H14.0238C14.0238 98.153 35.5007 77.2 61.9982 77.2C88.4958 77.2 109.976 98.153 109.976 124Z",
    fill: "url(#paint1_linear_5331_1400)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 80.4524,
    y: 74.5476,
    width: 28.7857,
    height: 28.7857,
    rx: 14.3929,
    fill: "#FBC0C0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.015 83.6134C102.32 83.3084 102.32 82.8138 102.015 82.5088C101.71 82.2038 101.215 82.2038 100.91 82.5088L95.2143 88.205L89.5181 82.5088C89.2131 82.2038 88.7186 82.2038 88.4136 82.5088C88.1085 82.8138 88.1085 83.3084 88.4136 83.6134L94.1097 89.3095L88.4136 95.0057C88.1085 95.3107 88.1085 95.8052 88.4136 96.1103C88.7186 96.4153 89.2131 96.4153 89.5181 96.1103L95.2143 90.4141L100.91 96.1103C101.215 96.4153 101.71 96.4153 102.015 96.1103C102.32 95.8052 102.32 95.3107 102.015 95.0057L96.3188 89.3095L102.015 83.6134Z",
    fill: "#DF2B44"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.181 82.3431C102.577 82.7397 102.577 83.3826 102.181 83.7791L96.6502 89.3095L102.181 94.84C102.577 95.2365 102.577 95.8794 102.181 96.2759C101.784 96.6725 101.141 96.6725 100.745 96.2759L95.2143 90.7455L89.6838 96.2759C89.2873 96.6725 88.6444 96.6725 88.2479 96.2759C87.8513 95.8794 87.8513 95.2365 88.2479 94.84L93.7783 89.3095L88.2479 83.7791C87.8513 83.3826 87.8513 82.7397 88.2479 82.3431C88.6444 81.9466 89.2873 81.9466 89.6838 82.3431L95.2143 87.8736L100.745 82.3431C101.141 81.9466 101.784 81.9466 102.181 82.3431ZM95.2143 88.205L89.5181 82.5088C89.2131 82.2038 88.7186 82.2038 88.4136 82.5088C88.1085 82.8138 88.1085 83.3084 88.4136 83.6134L94.1097 89.3095L88.4136 95.0057C88.1085 95.3107 88.1085 95.8052 88.4136 96.1103C88.7186 96.4153 89.2131 96.4153 89.5181 96.1103L95.2143 90.4141L100.91 96.1103C101.215 96.4153 101.71 96.4153 102.015 96.1103C102.32 95.8052 102.32 95.3107 102.015 95.0057L96.3188 89.3095L102.015 83.6134C102.32 83.3084 102.32 82.8138 102.015 82.5088C101.71 82.2038 101.215 82.2038 100.91 82.5088L95.2143 88.205Z",
    fill: "#DF2B44"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.264 82.2603C102.706 82.7026 102.706 83.4197 102.264 83.8619L96.8159 89.3095L102.264 94.7571C102.706 95.1994 102.706 95.9165 102.264 96.3588C101.821 96.8011 101.104 96.8011 100.662 96.3588L95.2143 90.9112L89.7667 96.3588C89.3244 96.8011 88.6073 96.8011 88.165 96.3588C87.7227 95.9165 87.7227 95.1994 88.165 94.7571L93.6126 89.3095L88.165 83.8619C87.7227 83.4197 87.7227 82.7026 88.165 82.2603C88.6073 81.818 89.3244 81.818 89.7667 82.2603L95.2143 87.7079L100.662 82.2603C101.104 81.818 101.821 81.818 102.264 82.2603ZM95.2143 87.8736L89.6838 82.3431C89.2873 81.9466 88.6444 81.9466 88.2479 82.3431C87.8513 82.7397 87.8513 83.3826 88.2479 83.7791L93.7783 89.3095L88.2479 94.84C87.8513 95.2365 87.8513 95.8794 88.2479 96.2759C88.6444 96.6725 89.2873 96.6725 89.6838 96.2759L95.2143 90.7455L100.745 96.2759C101.141 96.6725 101.784 96.6725 102.181 96.2759C102.577 95.8794 102.577 95.2365 102.181 94.84L96.6502 89.3095L102.181 83.7791C102.577 83.3826 102.577 82.7397 102.181 82.3431C101.784 81.9466 101.141 81.9466 100.745 82.3431L95.2143 87.8736Z",
    fill: "#DF2B44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5331_1400",
    x: 3.8938,
    y: 19.9176,
    width: 116.212,
    height: 116.212,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.065
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5331_1400"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5331_1400",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5331_1400",
    x1: 62.6013,
    y1: 72.0995,
    x2: 59.019,
    y2: 28.9814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392372,
    stopColor: "#DAE2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D1DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5331_1400",
    x1: 63.886,
    y1: 123.022,
    x2: 62.0538,
    y2: 77.9361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392372,
    stopColor: "#DAE2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D1DA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRestrictedContent);
export default __webpack_public_path__ + "static/media/UserRestrictedContent.66d0e1fd40e845a411b84ce6830ade9f.svg";
export { ForwardRef as ReactComponent };